import { render, staticRenderFns } from "./Americas.vue?vue&type=template&id=4554f016&"
import script from "./Americas.vue?vue&type=script&lang=js&"
export * from "./Americas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports